module.exports = __webpack_public_path__ + "img/RF.fb89f1b7.png";